import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.div`
	padding: 32px;
	display: flex;
	flex-direction: column;
	align-items: center;
	border-bottom: 1px solid ${helpers.color.border};

	&:first-of-type {
		padding-top: 32px;
	}

	&:last-of-type {
		padding-bottom: 0;
		border-bottom: none;
	}
`
